import { DataInterface } from '@lg-private/mongo-nav/src/types';
import { createAction } from 'redux-act';

import { createActionsAndExecutor } from 'baas-ui/redux_util';
import { AllowedDeprecatedFeatures } from 'admin-sdk';

const NAME = 'nav/';

export interface GroupReqPayload {
  groupId: string;
}

export const setNavigation = createAction<DataInterface>(`${NAME}set navigation data`);

export const [getAllowedDeprecatedFeaturesActions, getAllowedDeprecatedFeatures] = createActionsAndExecutor<
  GroupReqPayload,
  AllowedDeprecatedFeatures
>(
  `${NAME}get allowed deprecated features`,
  (client, { groupId }) =>
    () =>
      client.private().group(groupId).allowedDeprecatedFeatures()
);
